import { render, staticRenderFns } from "./selectRadio.vue?vue&type=template&id=9981c4cc&"
import script from "./selectRadio.vue?vue&type=script&lang=js&"
export * from "./selectRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports